import React, { useEffect } from 'react'
import { attorneyRoutes } from '../routes/index'
import { Header, Content, Footer } from './index'
import { useNavigate } from 'react-router-dom'

function AttorneyLayout() {
  const navgate = useNavigate()
  const token = window.sessionStorage.getItem('token')
  const role = window.sessionStorage.getItem('role')
  useEffect(() => {
    if (!token) {
      navgate('/login', { replace: true })
    } else if (role === 'C') {
      navgate('/login', { replace: true, state: { isCurrent: 'client' } })
    } else if (role === 'N') {
      navgate('/login', { replace: true, state: { isCurrent: 'admin' } })
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, role])
  return (
    <div className="d-flex flex-column vh-100">
      <Header />
      <Content routes={attorneyRoutes} />
      <Footer />
    </div>
  )
}

export default AttorneyLayout
